import { render, staticRenderFns } from "./ReassignmentModal.vue?vue&type=template&id=3cb2e4c4&"
import script from "./ReassignmentModal.vue?vue&type=script&lang=js&"
export * from "./ReassignmentModal.vue?vue&type=script&lang=js&"
import style0 from "./ReassignmentModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports